import { LIST_ITEM_DATA_ATR } from '../constants';
export const scrollToListItem = (itemId, containerElement) => {
    var _a;
    if (document) {
        const element = (containerElement || document).querySelector(`[${LIST_ITEM_DATA_ATR}="${itemId}"]`);
        if (element) {
            (_a = element.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(element, {
                block: 'nearest',
            });
        }
    }
};
